// "Why Farveladeland" — three bold statements, no paragraphs.
// Pure typography, lots of whitespace.

import { motion } from "framer-motion";
import { useLocale } from "@/lib/i18n";

const STATEMENTS_DA = [
  "Vi finder alt selv.",
  "En af hver, altid.",
  "Kun det vi selv ville beholde.",
];

const STATEMENTS_EN = [
  "We find everything ourselves.",
  "One of a kind. Always.",
  "Only what we'd keep.",
];

export function WhyFarveladeland() {
  const locale = useLocale();
  const items = locale === "da" ? STATEMENTS_DA : STATEMENTS_EN;
  const eyebrow = locale === "da" ? "Hvorfor Farveladeland" : "Why Farveladeland";

  return (
    <section className="relative mx-auto max-w-[1500px] px-6 py-20 md:px-10 md:py-44">
      <motion.p
        initial={{ opacity: 0, y: 12 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-80px" }}
        transition={{ duration: 0.7, ease: [0.22, 1, 0.36, 1] }}
        className="mb-16 text-center text-[10px] uppercase tracking-[0.32em] text-terracotta md:mb-24"
      >
        {eyebrow}
      </motion.p>

      <ul className="mx-auto flex max-w-4xl flex-col gap-14 md:gap-20">
        {items.map((s, i) => (
          <motion.li
            key={s}
            initial={{ opacity: 0, y: 28 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-80px" }}
            transition={{ duration: 0.8, delay: i * 0.12, ease: [0.22, 1, 0.36, 1] }}
            className="text-center font-display text-[clamp(1.8rem,4.5vw,3.4rem)] leading-[1.1] text-foreground"
          >
            <span className={i === 1 ? "display-italic text-terracotta" : ""}>{s}</span>
          </motion.li>
        ))}
      </ul>
    </section>
  );
}
